/* eslint-disable react/no-array-index-key */
import React, { memo, useMemo } from 'react';
import shortid from 'shortid';
import { isFunction } from 'lodash';

import TableRow from '../TableRow';
import TableCell from '../TableCell';

import './TableFooter.scss';

const TableFooter = ({ className = '', footer, footerCell, colSpan = 1 }) => {
  const footerId = useMemo(() => shortid(), []);
  const footerLength = footer?.length;

  return (
    <TableRow className={className}>
      {footer?.map((cell, i) => (
        <TableCell
          colSpan={isFunction(colSpan) ? colSpan(i) : colSpan}
          className={`${cell === 0 ? 'TableCell--zero' : ''}`}
          key={`${footerId} ${i}`}
        >
          {isFunction(footerCell) ? footerCell(cell, i, footerLength) : cell}
        </TableCell>
      ))}
    </TableRow>
  );
};

export default memo(TableFooter);
